export const MESSAGE = {
  ERROR: {
    INVALID_EMAIL_FORMAT: 'Invalid email format'
  }
};
